import React from 'react';
import { createClientMessage } from 'react-chatbot-kit';
import { CommentRole } from '../../../@types/llm-conversation';
import { ResourceType } from '../../../@types/resource-type';
import LlmService from '../../../services/llm.service';
import config from './config.js';
import { toast } from 'react-toastify';

const convertToLlmContent = (state, newMessage, timestamp, includeESD) => {
    const { messages } = state;
    const contents = messages.map((message) => {
        return {
            role: message.type === 'user' ? CommentRole.USER : CommentRole.SYSTEM,
            content: message.message,
            timestamp: timestamp
        };
    });
    const newMessageBloated = includeESD ? newMessage + '. Use hyperlink style to highlihght the node name. ' : newMessage;
    return [...contents, {
        role: CommentRole.USER,
        content: newMessageBloated,
        timestamp: timestamp
    }];
};

const ActionProvider = ({ createChatBotMessage, setState, state, children }) => {
    const [includeESD, setIncludeESD] = React.useState(false);
    const [llmModel, setLlmModel] = React.useState('');
    const timestamp = new Date().toISOString();    

    const handleReply = (message, currentWorkspaceObject) => {
        const contents = convertToLlmContent(state, message, timestamp, includeESD);
        const conversationHistory = {
            eventSequenceId: currentWorkspaceObject && currentWorkspaceObject.objectType === ResourceType.EVENT_SEQUENCE_TREES ? currentWorkspaceObject.object.id : 0,
            includeESD: currentWorkspaceObject && currentWorkspaceObject.objectType === ResourceType.EVENT_SEQUENCE_TREES ? includeESD : false,
            comments: contents,
            llm: llmModel,
            queryTime: timestamp,
            error: {
                code: 0,
                message: '',
                details: ''
            }
        };

        const thinkingMessage = createChatBotMessage('Thinking ...', {
            widget: 'thinking',
        });
        setState((prev) => ({
            ...prev,
            messages: [...prev.messages, thinkingMessage],
        }));

        LlmService.postLlmConversation(conversationHistory).then((response) => {
            const llmAnswer = response.data.comments[response.data.comments.length - 1].content;
            const botMessage = createChatBotMessage(llmAnswer);
            if (response.data.error.code != 0) {
                botMessage.message = JSON.parse(response.data.error.message).error.message;
            }
            setState((prev) => ({
                ...prev,
                messages: [...prev.messages.slice(0,-1), botMessage],
            }));
        }).catch((error) => { 
            const botMessage = createChatBotMessage('Sorry, I could not process your request at this time. Please try again later.');
            setState((prev) => ({
                ...prev,
                messages: [...prev.messages.slice(0,-1), botMessage],
            }));
            toast.error(error.message);
        }).finally(() => {
            const { messages } = state;
            localStorage.setItem(config.archiveName, JSON.stringify(messages));
        });
    };  

    const handleUploadFile = ({ name }) => {
        const userMessage = createClientMessage(`${name} File uploaded`,
            {
                widget: 'uploadFile',
                payload: { file: name },
            },
        );
        setState((prev) => ({
            ...prev,
            messages: [...prev.messages, userMessage],
        }));
    };

    const handleIncludeESD = (checked) => {
        setIncludeESD(checked);
    };

    const handleLLMModel = (llm) => {
        setLlmModel(llm);
    }
    
    const handleTriggerReply = (message, currentWorkspaceObject) => {
        const matches = message.toLowerCase().match(/clear history\s?(-?[0-9]*)$/);
        if (matches) {
            let count = matches[1] ? parseInt(matches[1]) : 0;
            clearMessages(count);
            return;
        }


        const userMessage = createClientMessage(message);
        setState((prev) => ({
            ...prev,
            messages: [...prev.messages, userMessage],
        }));

        handleReply(message, currentWorkspaceObject);
    }

    const clearMessages = (count) => {
        setState((prev) => ({
            ...prev,
            messages: [...prev.messages.slice(0,count)],
        }));
        const { messages } = state;
        localStorage.setItem(config.archiveName, JSON.stringify([...messages.slice(0,count)]));
    };
    
    return (
        <div>
            {React.Children.map(children, (child) => {
                return React.cloneElement(child, {
                    actions: {
                        handleReply,
                        handleIncludeESD,
                        handleLLMModel,
                        handleUploadFile,
                        clearMessages,
                        handleTriggerReply,
                    },
                });
            })}
        </div>
    );
};

export default ActionProvider;